// ** Redux
import { createListenerMiddleware } from "@reduxjs/toolkit";

// ** Actions
import { closeAuthModal } from "store/modules/global-common.slice";
import { setSearchSex } from "store/modules/shared-filters.slice";
import { login } from "../modules/auth/actions/login.action";
import { getUser } from "../modules/global-user/actions/get-user.action";

// ############################################################

export const userListenerMiddleware = createListenerMiddleware();

userListenerMiddleware.startListening({
	actionCreator: login.fulfilled,
	effect: async (action, listenerApi) => {
		const searchSexObject = action.payload.result.search_sex;
		const searchSexArray = Object.keys(searchSexObject).filter(
			(key) => searchSexObject[key] === true
		);

		listenerApi.dispatch(closeAuthModal());
		listenerApi.dispatch(getUser());

		// ** Shared filters
		listenerApi.dispatch(setSearchSex(searchSexArray));
	},
});

// ############################################################
